/* Glowie UX fixes part 4 (20.10.2026): product page CRO (sticky add to cart, cart add-on) */
(function () {
  /* ---------- Sticky Add to Cart bar (mobile, regular product pages) ---------- */
  function initStickyATC() {
    if (document.querySelector('[data-sk-config]')) return;           // Starter Kit page has its own bar
    var meta = document.querySelector('.product-single__meta');
    if (!meta || document.querySelector('.gx-sticky-atc')) return;
    var atc = meta.querySelector('button.add-to-cart[name="add"]');
    if (!atc) return;
    var title = meta.querySelector('.product-single__title');
    var priceBlock = meta.querySelector('.product-block.product-block--price');
    var og = document.querySelector('meta[property="og:image"]');

    var bar = document.createElement('div');
    bar.className = 'gx-sticky-atc';
    bar.innerHTML =
      '<div class="gx-sticky-atc__info">' +
        '<span class="gx-sticky-atc__thumb"></span>' +
        '<span class="gx-sticky-atc__text"><span class="gx-sticky-atc__title"></span><span class="gx-sticky-atc__price"></span></span>' +
      '</div>' +
      '<button type="button" class="gx-sticky-atc__btn"></button>';
    var thumb = bar.querySelector('.gx-sticky-atc__thumb');
    var btn = bar.querySelector('.gx-sticky-atc__btn');

    if (og && og.content) {
      var img = document.createElement('img');
      img.src = og.content.replace(/^http:/, 'https:') + (og.content.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy';
      thumb.appendChild(img);
    } else {
      thumb.remove();
    }

    function sync() {
      bar.querySelector('.gx-sticky-atc__title').textContent = title ? title.textContent.trim() : '';
      var p = bar.querySelector('.gx-sticky-atc__price');
      p.innerHTML = '';
      if (priceBlock) {
        var compare = priceBlock.querySelector('[data-compare-price]');
        var price = priceBlock.querySelector('[data-product-price]');
        if (compare && compare.textContent.trim() && compare.offsetParent !== null) {
          var s = document.createElement('s'); s.textContent = compare.textContent.trim(); p.appendChild(s);
        }
        if (price) {
          var b = document.createElement('b'); b.textContent = price.textContent.trim(); p.appendChild(b);
        }
      }
      var label = atc.querySelector('[data-add-to-cart-text]');
      var text = label ? label.childNodes[0] && label.childNodes[0].textContent.trim() : atc.textContent.trim();
      btn.textContent = text || 'Add to cart';
      btn.disabled = atc.disabled;
    }
    sync();
    btn.addEventListener('click', function () { atc.click(); });
    if (priceBlock) new MutationObserver(sync).observe(priceBlock, { childList: true, subtree: true, characterData: true });
    new MutationObserver(sync).observe(atc, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    document.body.appendChild(bar);

    function show(on) {
      bar.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('gx-sticky-on', on);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);   // only once the real button has scrolled up out of view
      }).observe(atc);
    }
  }

  /* ---------- Free shipping: one message everywhere, true for the visitor's country ---------- */
  // Thresholds are in AUD and match Settings > Shipping and delivery (General profile).
  var DHL_ZONE = ['NZ','CN','HK','IN','ID','JP','MY','PK','PH','RU','SG','KR','LK','TW','TH',
                  'BE','DK','FR','DE','HU','IS','IE','IT','LT','LU','MC','PT','RO','CH','TR','UA','GB'];
  var PLACE = { US: 'the US', GB: 'the UK', CA: 'Canada', NZ: 'New Zealand' };
  function country() { return (window.Shopify && Shopify.country) || 'AU'; }
  function shipRule() {
    var c = country();
    if (c === 'AU') return { aud: 100, method: 'shipping' };
    if (c === 'US' || c === 'CA') return { aud: 150, method: 'express shipping' };
    if (DHL_ZONE.indexOf(c) > -1) return { aud: 274, method: 'DHL express shipping' };
    return null;
  }
  function money(amount, decimals) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    try {
      return new Intl.NumberFormat('en-' + country(), { style: 'currency', currency: cur, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    } catch (e) { return cur + ' ' + amount; }
  }
  function localThreshold(aud) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return money(cur === 'AUD' ? aud : Math.ceil(aud * rate), 0);   // rounded up so the promise always holds
  }
  function placeName(c) {
    if (PLACE[c]) return PLACE[c];
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(c); } catch (e) { return c; }
  }
  function swap(el, text) {
    if (!el) return;
    if (!el.hasAttribute('data-gx-orig')) el.setAttribute('data-gx-orig', el.textContent);
    if (el.textContent !== text) el.textContent = text;
  }
  function initShippingText() {
    var r = shipRule();
    if (!r || country() === 'AU') return;            // Australian copy is already right
    var amt = localThreshold(r.aud);
    var line = 'Free ' + r.method + ' on orders over ' + amt;
    document.querySelectorAll('.cn-announcement-text').forEach(function (el) {
      if (/free shipping/i.test(el.getAttribute('data-gx-orig') || el.textContent)) swap(el, ('Free ' + r.method + ' on all orders ' + amt + '+').toUpperCase());
    });
    document.querySelectorAll('.sales-point .icon-and-text > span, .gx-usp .svg-text').forEach(function (el) {
      if (/free .*shipping/i.test(el.getAttribute('data-gx-orig') || el.textContent)) swap(el, line);
    });
    document.querySelectorAll('.ib-text-wrap').forEach(function (w) {
      var t = w.querySelector('.ib-title');
      if (!t || !/free shipping/i.test(t.getAttribute('data-gx-orig') || t.textContent)) return;
      swap(t, 'Free ' + r.method);
      swap(w.querySelector('.ib-subtitle'), 'over ' + amt);
      var desc = w.querySelector('.ib-desc');
      swap(desc, 'to ' + placeName(country()));
      if (desc) desc.style.textTransform = 'none';      // the badge styles this line lowercase
    });
    document.querySelectorAll('.sk-trust-item span').forEach(function (el) {
      if (/free shipping on all kits/i.test(el.getAttribute('data-gx-orig') || el.textContent)) swap(el, 'Free ' + r.method + ' on all kits ' + amt + '+');
    });
  }

  // Cart progress bar: use the visitor's real free-shipping threshold (theme setting is the Australian one)
  function wrapMilestone() {
    var orig = window.updateCartMilestoneUI;
    if (typeof orig !== 'function' || orig.__gx) return;
    var wrapped = function (prefix) {
      var card = document.getElementById(prefix + '-shipping-card');
      var r = shipRule();
      if (card && r && country() !== 'AU') {
        var before = {};
        [1, 2, 3].forEach(function (i) {
          before[i] = card.dataset['t' + i];
          if (/shipping/i.test(card.dataset['l' + i] || '')) card.dataset['t' + i] = String(r.aud);
        });
        // keep the tiers in order; if the new number would jump past another tier, leave the bar as it was
        var last = -1, ok = true;
        [1, 2, 3].forEach(function (i) {
          if (card.dataset['t' + i + 'Enabled'] !== 'true') return;
          var v = parseFloat(card.dataset['t' + i]);
          if (v < last) ok = false;
          last = v;
        });
        if (!ok) [1, 2, 3].forEach(function (i) { card.dataset['t' + i] = before[i]; });
      }
      return orig.apply(this, arguments);
    };
    wrapped.__gx = true;
    window.updateCartMilestoneUI = wrapped;
    if (document.getElementById('cd-shipping-card')) wrapped('cd');
    if (document.getElementById('cp-shipping-card')) wrapped('cp');
  }

  /* ---------- Dispatch date under Add to Cart ---------- */
  function initDispatch() {
    document.querySelectorAll('[data-gx-dispatch]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 2;
      var out = el.querySelector('[data-gx-dispatch-text]');
      if (!out) return;
      try {
        // business days are counted on Sydney time, where orders are packed
        var parts = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
        var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return +parts[i].value; };
        var d = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12));
        var n = 0;
        while (n < days) { d.setUTCDate(d.getUTCDate() + 1); var wd = d.getUTCDay(); if (wd !== 0 && wd !== 6) n++; }
        var label = new Intl.DateTimeFormat('en-' + country(), { weekday: 'long', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d);
        out.textContent = 'Order today and it ships by ' + label;
      } catch (e) { /* keep the fallback text */ }
    });
  }

  /* ---------- Good to know: bring the sales points (shipping, checkout, guarantee) in as extra rows ---------- */
  function initUSPs() {
    var meta = document.querySelector('.product-single__meta');
    var gk = meta && meta.querySelector('.prod_fea_block .product-form__goodknow--container');
    if (!gk) return;
    meta.querySelectorAll('.product-block--sales-point').forEach(function (block) {
      var li = block.querySelector('.sales-point');
      if (!li) return;
      var icon = li.querySelector('svg');
      var text = li.querySelector('.icon-and-text > span');
      if (!text) return;
      var row = document.createElement('div');
      row.className = 'product-form__goodknow--item gx-usp';
      row.innerHTML = '<span class="svg-icon"></span><span class="svg-text"></span>';
      if (icon) row.firstChild.appendChild(icon.cloneNode(true));
      row.lastChild.textContent = text.textContent;
      gk.appendChild(row);
      block.classList.add('gx-usp-moved');   // the block stays (and stays editable in the theme editor), just hidden
    });
  }

  /* ---------- What's in the box + size guide toggles (contents read from the product description) ---------- */
  function initBox() {
    document.querySelectorAll('[data-gx-box]').forEach(function (box) {
      var btns = box.querySelectorAll('[data-gx-toggle]');
      var panelOf = function (b) { return document.getElementById(b.getAttribute('aria-controls')); };
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = panelOf(btn);
          if (!panel) return;
          var opening = panel.hasAttribute('hidden');
          btns.forEach(function (o) { var p = panelOf(o); if (p) p.setAttribute('hidden', ''); o.setAttribute('aria-expanded', 'false'); });
          if (opening) { panel.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });

      var meta = box.closest('.product-single__meta') || document;
      var desc = meta.querySelector('#readMoreDescription') || meta;
      var heading = null;
      desc.querySelectorAll('b, strong, p, h2, h3, h4, h5, h6').forEach(function (el) {
        if (!heading && /^\s*what you get/i.test(el.textContent)) heading = el;
      });
      // the list follows the heading, sometimes one level up (e.g. <div><b>WHAT YOU GET</b><br></div><ul>)
      var list = null, el = heading;
      while (!list && el && el !== desc) {
        var sib = el.nextElementSibling;
        for (var i = 0; sib && i < 3; i++, sib = sib.nextElementSibling) { if (sib.tagName === 'UL') { list = sib; break; } }
        el = el.parentElement;
      }
      if (!list) return;
      var items = [];
      list.querySelectorAll(':scope > li').forEach(function (li) {
        var t = li.textContent.replace(/\s+/g, ' ').trim();
        if (!t) return;
        if (/^\(/.test(t) && items.length) items[items.length - 1] += ' ' + t; else items.push(t);
      });
      if (!items.length) return;
      items.sort(function (a, b) { return (/nails in/i.test(b) ? 1 : 0) - (/nails in/i.test(a) ? 1 : 0); });
      var holder = box.querySelector('[data-gx-box-list]');
      var tick = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#531411" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      holder.innerHTML = '';
      items.forEach(function (t) {
        var row = document.createElement('div');
        row.className = 'product-form__goodknow--item';
        row.innerHTML = '<span class="svg-icon">' + tick + '</span><span class="svg-text"></span>';
        row.querySelector('.svg-text').textContent = t;
        holder.appendChild(row);
      });
      var boxBtn = box.querySelector('[data-gx-box-btn]');
      if (boxBtn) boxBtn.removeAttribute('hidden');
      box.removeAttribute('hidden');
    });
  }

  /* ---------- Cart drawer: "Complete your mani" add-on ---------- */
  var ADDON = { handle: 'brush-on-nail-glue', note: 'Longer wear' };
  var addonProduct = null;
  function getJSON(url) {
    var f = window.originalFetch || window.fetch;
    return f(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
  }
  function isNailSet(handle) {
    var key = 'gx-nailset-' + handle;
    try { var v = sessionStorage.getItem(key); if (v !== null) return Promise.resolve(v === '1'); } catch (e) {}
    return getJSON('/products/' + handle + '.js').then(function (p) {
      var yes = !!(p && /\d+\s*nails in\s*\d+/i.test(p.description || ''));
      try { sessionStorage.setItem(key, yes ? '1' : '0'); } catch (e) {}
      return yes;
    }).catch(function () { return false; });
  }
  var addonBusy = false;
  function renderAddon() {
    var c = document.querySelector('[data-cart-drawer-container]');
    if (!c || addonBusy) return;
    addonBusy = true;
    var old = c.querySelector('.gx-addon');
    getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.items.length) return null;
      var covered = cart.items.some(function (i) {
        return /^brush-on-nail-glue/.test(i.handle) || i.handle === 'glowie-starter-kit-bundle';
      });
      if (covered) return null;
      var handles = cart.items.map(function (i) { return i.handle; }).filter(function (h, n, a) { return a.indexOf(h) === n; }).slice(0, 6);
      return Promise.all(handles.map(isNailSet)).then(function (r) { return r.indexOf(true) > -1; });
    }).then(function (show) {
      if (!show) { if (old) old.remove(); return; }
      return (addonProduct ? Promise.resolve(addonProduct) : getJSON('/products/' + ADDON.handle + '.js')).then(function (p) {
        addonProduct = p;
        var v = p && p.variants && p.variants.filter(function (x) { return x.available; })[0];
        var footer = c.querySelector('.cd-footer-area');
        if (!v || !footer) { if (old) old.remove(); return; }
        if (old && old.getAttribute('data-variant') === String(v.id) && old.nextElementSibling === footer) return;
        if (old) old.remove();
        var box = document.createElement('div');
        box.className = 'gx-addon';
        box.setAttribute('data-variant', v.id);
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        box.innerHTML =
          '<p class="gx-addon__head">Complete your mani</p>' +
          '<div class="gx-addon__row">' +
            (img ? '<img class="gx-addon__img" alt="" width="56" height="56" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120">' : '') +
            '<div class="gx-addon__info"><span class="gx-addon__title"></span><span class="gx-addon__note"></span><span class="gx-addon__price"></span></div>' +
            '<button type="button" class="gx-addon__btn">Add</button>' +
          '</div>';
        box.querySelector('.gx-addon__title').textContent = p.title;
        box.querySelector('.gx-addon__note').textContent = ADDON.note;
        box.querySelector('.gx-addon__price').textContent = money(v.price / 100, 2);
        var b = box.querySelector('.gx-addon__btn');
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = 'Adding';
          window.fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
            .then(function () { return typeof window.refreshCartDrawer === 'function' ? window.refreshCartDrawer(false) : null; })
            .catch(function () { b.disabled = false; b.textContent = 'Add'; });
        });
        footer.parentNode.insertBefore(box, footer);
      });
    }).catch(function () {}).then(function () { addonBusy = false; });
  }
  function initAddon() {
    var c = document.querySelector('[data-cart-drawer-container]');
    if (!c) return;
    var t;
    var schedule = function () { clearTimeout(t); t = setTimeout(renderAddon, 150); };
    new MutationObserver(schedule).observe(c, { childList: true });   // the drawer swaps its whole content on refresh
    new MutationObserver(function () { if (c.classList.contains('is-open')) schedule(); }).observe(c, { attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  function init() {
    initStickyATC();
    wrapMilestone();
    initUSPs();
    initShippingText();
    setTimeout(initShippingText, 1500);   // the announcement bar can re-render after load
    initDispatch();
    initBox();
    initAddon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
